import { render, staticRenderFns } from "./PolicySlider.vue?vue&type=template&id=30f4a14e"
import script from "./PolicySlider.vue?vue&type=script&lang=js"
export * from "./PolicySlider.vue?vue&type=script&lang=js"
import style0 from "./PolicySlider.vue?vue&type=style&index=0&id=30f4a14e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports